/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/tabindex-no-positive */
import { motion } from 'framer-motion';
import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import ThreeDotsLoader from '../LoadingDots';

function OtpScreen({
    Email, otpError, setotp, setotpError, handleOtp, inputfocus, otp, resendOtp, loading, setiniitialAuthentication, loginError,
}) {
    const [timeLeft, setTimeLeft] = useState(30);
    const [enableReset, setEnablereset] = useState(false);
    const [segments, setSegments] = React.useState(['', '', '', '', '', '']);

    function onPaste(event) {
        const pasted = event.clipboardData.getData('text/plain');
        setSegments(pasted.split('').slice(0, segments.length));
    }

    // toast.configure();
    const handleResend = () => {
        resendOtp(Email);
        setEnablereset(false);
        setTimeLeft(30);
    };

    function Countdown({ seconds }) {
        useEffect(() => {
            if (timeLeft >= 0) {
                const intervalId = setInterval(() => {
                    setTimeLeft((t) => t - 1);
                }, 1000);

                return () => clearInterval(intervalId);
            }
            setEnablereset(true);
            return (() => clearInterval(timeLeft));
        }, [timeLeft]);
        if (timeLeft >= 0) {
            return ` in ${timeLeft}s`;
        }
    }

    return (
        <div className="flex  h-custom w-full">

            <div className="w-[43%] sm:opacity-100 opacity-50">
                <img src="/images/falcon_login_image.jpg" alt="icon" className="h-custom w-full" />
            </div>
            <div className="flex justify-center items-center h-auto w-[57%] relative">
                <div className=" lg:top-[30px] pt-4 sm:pl-10 pl-6 sm:-top-0 -top-[70px] left-0 absolute ">
                    <a
                        href="javascript:void(0)"
                        className="flex items-center"
                        onClick={() => {
                            setotp({
                                one: '',
                                two: '',
                                three: '',
                                four: '',
                                five: '',
                                six: '',
                            });
                            setiniitialAuthentication(false);
                        }}
                    >
                        <img src="/images/Union24.svg" alt="icon" className="pr-1" />
                        Back
                    </a>
                </div>
                <div className="admin-login-otp-page">
                    <form onSubmit={(e) => handleOtp(e)}>
                        <h5 className="text-xs1 font-bold text-[#555259] pb-6">
                            <span className="text-[#ED1C24]">FALCON</span>
                            {' '}
                            Login
                        </h5>
                        <div className="pb-[18px]">
                            <p className="text-sm font-normal text-[#555259]">{`OTP has been sent to the registered ${loginError ? loginError.toLowerCase() === 'mobile number' ? 'email address' : 'mobile number' : 'email address and mobile number.'} `}</p>
                            <p className="text-sm font-normal text-[#555259]">Valid for 10 mins</p>
                        </div>
                        <p className="text-sm font-normal text-[#555259] pb-7">Please enter the 6 Digit OTP to verify your login</p>
                        {otpError
                            && (
                                <motion.p
                                    animate={{ y: 10 }}
                                    transition={{ ease: 'backIn', duration: 1, type: 'spring' }}
                                    className="text-xs4 font-light text-[#ED1C24] error-message-login text-center"
                                >
                                    Invalid OTP entered. Please try again.
                                </motion.p>
                            )}
                        <div className="digit-group flex justify-center pt-7">
                            <label htmlFor="digit-1" />
                            <input
                                type="text"
                                className={`w-12 h-12  border-b-2 sm:mr-6 mr-5 bg-[transparent] outline-0 text-center md:text-xs1 text-2xl font-normal text-[#090406] otp-input err-otp ${otpError ? 'border-[#ED1C24]' : 'border-[#A9B2BE]'} `}
                                name="digit-1"
                                id="digit-1"
                                data-next="digit-2"
                                tabIndex="1"
                                onChange={(e) => setotp((prevState) => ({
                                    ...prevState,
                                    one: e.target.value,
                                }))}
                                value={otp.one}
                                maxLength="1"
                                onFocus={() => setotpError(false)}
                                onKeyUp={(e) => inputfocus(e)}
                                onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, ''); }}
                                onPaste={onPaste}

                            />
                            <label htmlFor="digit-2" />
                            <input
                                type="text"
                                className={`w-12 h-12 
             border-b-2 sm:mr-6 mr-5 bg-[transparent] outline-0 text-center md:text-xs1 text-2xl font-normal text-[#090406] otp-input err-otp ${otpError ? 'border-[#ED1C24]' : 'border-[#A9B2BE]'}`}
                                name="digit-2"
                                maxLength="1"
                                onFocus={() => setotpError(false)}
                                id="digit-2"
                                data-next="digit-3"
                                tabIndex="2"
                                data-previous="digit-1"
                                onChange={(e) => setotp((prevState) => ({
                                    ...prevState,
                                    two: e.target.value,
                                }))}
                                value={otp.two}
                                onKeyUp={(e) => inputfocus(e)}
                                onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9.]/g, ''); }}

                            />
                            <label htmlFor="digit-3" />
                            <input
                                type="text"
                                className={`w-12 h-12 
             border-b-2 sm:mr-6 mr-5 bg-[transparent] outline-0 text-center md:text-xs1 text-2xl font-normal text-[#090406] otp-input err-otp ${otpError ? 'border-[#ED1C24]' : 'border-[#A9B2BE]'}`}
                                name="digit-3"
                                maxLength="1"
                                onFocus={() => setotpError(false)}
                                id="digit-3"
                                tabIndex="3"
                                data-next="digit-4"
                                data-previous="digit-2"
                                onChange={(e) => setotp((prevState) => ({
                                    ...prevState,
                                    three: e.target.value,
                                }))}
                                value={otp.three}
                                onKeyUp={(e) => inputfocus(e)}
                                onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9.]/g, ''); }}

                            />
                            <label htmlFor="digit-4" />
                            <input
                                type="text"
                                className={`w-12 h-12 
             border-b-2 sm:mr-6 mr-5 bg-[transparent] outline-0 text-center md:text-xs1 text-2xl font-normal text-[#090406] otp-input err-otp ${otpError ? 'border-[#ED1C24]' : 'border-[#A9B2BE]'}`}
                                name="digit-4"
                                id="digit-4"
                                maxLength="1"
                                onFocus={() => setotpError(false)}
                                tabIndex="4"
                                data-next="digit-5"
                                data-previous="digit-14"
                                onChange={(e) => setotp((prevState) => ({
                                    ...prevState,
                                    four: e.target.value,
                                }))}
                                value={otp.four}
                                onKeyUp={(e) => inputfocus(e)}
                                onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9.]/g, ''); }}

                            />
                            <label htmlFor="digit-5" />
                            <input
                                type="text"
                                className={`w-12 h-12 
             border-b-2 sm:mr-6 mr-5 bg-[transparent] outline-0 text-center md:text-xs1 text-2xl font-normal text-[#090406] otp-input err-otp ${otpError ? 'border-[#ED1C24]' : 'border-[#A9B2BE]'}`}
                                name="digit-5"
                                id="digit-5"
                                data-next="digit-6"
                                tabIndex="5"
                                maxLength="1"
                                onFocus={() => setotpError(false)}
                                data-previous="digit-4"
                                onChange={(e) => setotp((prevState) => ({
                                    ...prevState,
                                    five: e.target.value,
                                }))}
                                value={otp.five}
                                onKeyUp={(e) => inputfocus(e)}
                                onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9.]/g, ''); }}

                            />
                            {' '}
                            <label htmlFor="digit-6" />
                            {/* <!-- If it is a error state then border color will be "#ED1C24" --> */}
                            <input
                                type="text"
                                className={`w-12 h-12 
             border-b-2 sm:mr-6 mr-5 bg-[transparent] outline-0 text-center md:text-xs1 text-2xl font-normal text-[#090406] otp-input err-otp ${otpError ? 'border-[#ED1C24]' : 'border-[#A9B2BE]'}`}
                                name="digit-6"
                                tabIndex="6"
                                id="digit-6"
                                data-next="digit-7"
                                maxLength="1"
                                onFocus={() => setotpError(false)}
                                data-previous="digit-5"
                                onChange={(e) => setotp((prevState) => ({
                                    ...prevState,
                                    six: e.target.value,
                                }))}
                                value={otp.six}
                                onKeyUp={(e) => inputfocus(e)}
                                onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9.]/g, ''); }}
                            />
                            {' '}

                        </div>
                        <div className="flex justify-center pt-12 pb-[22px] next">
                            {/* <!-- for disabled button bg-[#BABABA] --> */}
                            <motion.button
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                type="submit"
                                data-testid="submit-btn"
                                className="md:w-[310px] w-[250px] md:h-[52px] h-10 text-center bg-[#555259] md:rounded-2xl rounded-xl sm:text-lg sm:font-semibold text-base text-[#FFFFFF] hover:bg-[#808285] flex center justify-center items-center"
                                disabled={loading}
                            >
                                {loading ? <ThreeDotsLoader /> : 'Submit'}
                            </motion.button>
                        </div>
                        <p className="text-xs2 font-normal text-[#777777] text-center didnot-get">
                            Didn’t get the OTP?
                            <span className={`${enableReset === true ? 'cursor-pointer text-[#777777]' : ' text-[#B5B5B5] pointer-events-none'}`} onClick={() => handleResend()}>
                                {' '}
                                Resend
                                <Countdown seconds={30} />
                            </span>
                        </p>
                        <p className="text-xs2 font-normal text-[#B5B5B5] text-center didnot-get1 hidden">
                            Didn’t get the OTP?
                            <button
                                type="button"
                                className={`text-[#777777] resend-admin-otp ${enableReset === true ? 'cursor-pointer' : 'pointer-events-none'}`}
                            >
                                {' '}
                                Resend
                                {/* <Countdown  seconds={5}/> */}
                            </button>
                        </p>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default OtpScreen;
